import React from 'react';

export const Header = ({ selectedNavitem }) => {
    return (
        <>
            <header>
                <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
                    <div className="container">
                        <a className="navbar-brand d-flex align-items-center" href="/">
                            <div className='me-3'><img height="50" src="img/se-logo-106x80.png" alt="Schwabe Enterprises Logo" /></div>
                            <span className="fw-bold fs-4 text-dark tracking-tight">SCHWABE ENTERPRISES</span>
                        </a>

                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarContent"
                            aria-controls="navbarContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarContent">
                            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                <li className="nav-item">
                                    <a className={`nav-link fs-4 px-3 ${selectedNavitem === 'home' ? 'active fw-bold text-primary' : ''}`} href="/">Home</a>
                                </li>
                                <li className="nav-item">
                                    <a className={`nav-link fs-4 px-3 ${selectedNavitem === 'about' ? 'active fw-bold text-primary' : ''}`} href="/about">About</a>
                                </li>
                                <li className="nav-item">
                                    <a className={`nav-link fs-4 px-3 ${selectedNavitem === 'press' ? 'active fw-bold text-primary' : ''}`} href="/press">Press</a>
                                </li>
                                <li className="nav-item">
                                    <a className={`nav-link fs-4 px-3 ${selectedNavitem === 'services' ? 'active fw-bold text-primary' : ''}`} href="/services">Services</a>
                                </li>
                                <li className="nav-item">
                                    <a className={`nav-link fs-4 px-3 ${selectedNavitem === 'incubator' ? 'active fw-bold text-primary' : ''}`} href="/incubator">Incubator</a>
                                </li>
                                <li className="nav-item">
                                    <a className={`nav-link fs-4 px-3 ${selectedNavitem === 'contact' ? 'active fw-bold text-primary' : ''}`} href="/contact">Contact</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
        </>
    );
};